// @ts-nocheck
import React, { useState } from "react";
import { DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ProcessForm } from "./ProcessForm";
import { generateProcessStepCode } from "./process-stage-machines.helper";
import { trpcClient } from "@/lib/trpc";
import { toast } from "sonner";
import { useQueryClient } from "@tanstack/react-query";
import { Cog } from "lucide-react";

interface ProcessFormModalProps {
  onSuccess?: (newItem: { id: string; label: string; original?: any }) => void;
  onCancel?: () => void;
  initialData?: any;
  params?: Record<string, any>;
}

export function ProcessFormModal({
  onSuccess,
  onCancel,
  initialData,
  params,
}: ProcessFormModalProps) {
  const queryClient = useQueryClient();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialName = initialData?.name || initialData?.label || "";
  const initialGroup = initialData?.group || params?.group || "";

  const handleSubmit = async (data: any) => {
    setIsSubmitting(true);
    try {
      const res: any = await trpcClient.technical.processes.create.mutate(data);

      await queryClient.invalidateQueries({ queryKey: ["processes"] });
      await queryClient.invalidateQueries({ queryKey: ["processes-lookup"] });
      await queryClient.invalidateQueries({ queryKey: ["combobox"] });

      toast.success(`Đã thêm công đoạn: ${res.name || res.stepId}`);

      if (onSuccess && res) {
        onSuccess({
          id: res.stepId || res.id,
          label: res.name || res.stepId,
          original: res,
        });
      }
    } catch (error: any) {
      toast.error(`Lỗi tạo công đoạn: ${error.message || "Không xác định"}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="space-y-4 py-1">
      <DialogHeader className="pb-2 border-b">
        <DialogTitle className="flex items-center gap-2 text-lg font-bold text-slate-800">
          <Cog className="w-5 h-5 text-indigo-600" />
          Khai báo Công đoạn sản xuất mới
        </DialogTitle>
        <DialogDescription className="text-xs text-slate-500">
          Nhập tên công đoạn để sử dụng ngay; mã công đoạn và định mức kỹ thuật được tự động khởi tạo chuẩn xưởng.
        </DialogDescription>
      </DialogHeader>

      <div className="-mx-2 px-2 max-h-[75vh] overflow-y-auto">
        <ProcessForm
          isQuickModal
          lockedGroup={Boolean(initialGroup)}
          onSuccess={handleSubmit}
          onCancel={onCancel || (() => {})}
          defaultValues={{
            name: initialName,
            group: initialGroup,
            stepId: initialName
              ? generateProcessStepCode(initialName, initialGroup)
              : "",
            ...(initialData || {}),
          }}
        />
      </div>
    </div>
  );
}

export default ProcessFormModal;
